import { defineComponent as p, ref as g, h as r } from "vue";
import { normalizeHue as b } from "./ghl-ui.es914.js";
import { on as s, off as c } from "./ghl-ui.es710.js";
const n = "12px", v = 12, t = "6px", R = 6, x = "linear-gradient(90deg,red,#ff0 16.66%,#0f0 33.33%,#0ff 50%,#00f 66.66%,#f0f 83.33%,red)", H = p({
  name: "HueSlider",
  props: {
    clsPrefix: {
      type: String,
      required: !0
    },
    hue: {
      type: Number,
      required: !0
    },
    onUpdateHue: {
      type: Function,
      required: !0
    },
    onComplete: Function
  },
  setup(e) {
    const i = g(null);
    function a(o) {
      i.value && (s("mousemove", document, u), s("mouseup", document, l), u(o));
    }
    function u(o) {
      const {
        value: d
      } = i;
      if (!d)
        return;
      const {
        width: f,
        left: h
      } = d.getBoundingClientRect(), m = b((o.clientX - h - R) / (f - v) * 360);
      e.onUpdateHue(m);
    }
    function l() {
      var o;
      c("mousemove", document, u), c("mouseup", document, l), (o = e.onComplete) === null || o === void 0 || o.call(e);
    }
    return {
      railRef: i,
      handleMouseDown: a
    };
  },
  render() {
    const {
      clsPrefix: e
    } = this;
    return r("div", {
      class: `${e}-color-picker-slider`,
      style: {
        height: n,
        borderRadius: t
      }
    }, r("div", {
      ref: "railRef",
      style: {
        boxShadow: "inset 0 0 2px 0 rgba(0, 0, 0, .24)",
        boxSizing: "border-box",
        backgroundImage: x,
        height: n,
        borderRadius: t,
        position: "relative"
      },
      onMousedown: this.handleMouseDown
    }, r("div", {
      style: {
        position: "absolute",
        left: t,
        right: t,
        top: 0,
        bottom: 0
      }
    }, r("div", {
      class: `${e}-color-picker-handle`,
      style: {
        left: `calc((${this.hue}%) / 359 * 100 - ${t})`,
        borderRadius: t,
        width: n,
        height: n
      }
    }, r("div", {
      class: `${e}-color-picker-handle__fill`,
      style: {
        backgroundColor: `hsl(${this.hue}, 100%, 50%)`,
        borderRadius: t,
        width: n,
        height: n
      }
    })))));
  }
});
export {
  H as default
};
